import { call, put } from 'redux-saga/effects';
import GetAnnouncementsActions from '../redux/GetAnnouncementsRedux';
import { api } from './api';


export function* getAnnouncements(action: any): Generator<any, void, any> {
  // const { data } = action
  const { navigate } = action;
  const response = yield call(api.getAnnouncements);

  // success?
  if (response.ok) {
    // Extract the data array from the response
    const announcementsData = response.data?.data || response.data || [];
    yield put(GetAnnouncementsActions.getAnnouncementsSuccess(announcementsData));
  } else {
    if (response.status === 401 && navigate) {
      // redirect to tutorial page
      navigate('/tutorial');
    }
    yield put(GetAnnouncementsActions.getAnnouncementsFailure());
  }
}